<template>
  <div
    class="send-order"
    :class="{'send-order--sent': status=='succes', 'send-order--error': status=='error'}"
  >
    <div class='send-order__client'>{{orderItem.client.name}}</div>
    <div class='send-order__location'>{{orderItem.client.address.line1}}, {{orderItem.client.address.zipCode}}, {{orderItem.client.address.city}}, {{orderItem.client.address.country}}</div>
    <div class='send-order__quantity-price'>
			<div class="send-order__quantity">{{amount}} {{resource('items')}}</div>
			<div class="send-order__price">{{price | price}}</div>
		</div>
    <div class='send-order__date'>
      {{resource('startDateOrder')}}<br />
      {{orderItem.added | date}}
    </div>

		<div class="send-order__sendlist">
      <button
        class="button--secondary"
        v-if="!status"
        @click="listOverlay = true"
      >{{resource('sendList')}}</button>
    </div>

    <div class="send-order__send">
      <button
        class="button--primary"
        v-if="!status"
        @click="readyOrder()"
      >{{resource('sendOrder')}}</button>
      <icon
        name="loader"
        size="26px"
        :animation="{name:'rotate', duration: '1.5s', repeat:'infinite'}"
        v-if="status == 'sending'"
      />

      <div
        class="send-order__succes"
        v-if="status === 'succes'"
      >
        <icon name="check" />{{resource('succes')}}</div>
      <div
        class="send-order__error"
        v-if="status === 'error'"
      >
        {{resource('error')}} <span
          class="button retry-button"
          @click="status = ''"
        >
          <icon name="retry" /></span>
      </div>
    </div>
		<div class="send-order__list-overlay send-order-prompt" v-show="listOverlay">
			<div class="send-order-prompt__title">{{listOverlayTitle}}</div>
			<div class="send-order-prompt__text">{{resource('listOverlayText')}}</div>
			<div class="send-order-prompt__btns">
				<button class="button button--secondary" @click="readyList()">{{resource('confirm')}}</button>
				<button class="button button--outline button--cancel" @click="listOverlay = false">{{resource('cancel')}}</button>
			</div>
		</div>
  </div>
</template>

<style lang="scss">
.send-order {
  display: grid;
  grid-template-columns: 2fr 1fr auto auto;
  grid-template-areas: "client date sendlist send"
											 "location date sendlist send"
											 "quantity . . .";
  grid-template-rows: 1fr 1fr auto;
  padding: $content;
  position: relative;
  border-bottom: 1px solid $order__border;
  &__client {
    grid-area: client;
    font-weight: bold;
  }
  &__location {
    grid-area: location;
  }
  &__quantity-price {
    grid-area: quantity;
		justify-self: start;
		display: flex;
		padding: 5px 10px;
		margin-top: 5px;
		background: #f5f5f5;
		border: 1px solid #ccc;
		border-radius: 3px;;
	}
	&__price{
		margin-left: 20px;
	}
  &__date {
    grid-area: date;
    align-self: center;
  }
  &__send {
    grid-area: send;
    align-self: center;
    justify-self: flex-end;
  }
	&__sendlist {
    grid-area: sendlist;
    align-self: center;
    justify-self: flex-end;
		margin-right: 10px;
  }
  &__succes {
    font-weight: bold;
    color: $ok;
    svg {
      margin-right: $component;
    }
  }
  &__error {
    color: $error;
    font-weight: bold;
  }
  &--sent {
    background: #f5f5f5;
    color: #ccc;
  }
  &--error {
    background: #f5f5f5;
    color: #ccc;
  }
}
.retry-button {
  background: $error;
  color: #fff;
  margin-left: $content;
}
.send-order-prompt{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: $prompt__bg;
	color: $prompt__color;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	&__title{
		font-weight: bold;
		font-size: $fs1;
	}
	&__text{
		margin: 5px 0;
	}
	&__btns{
		display: flex;
		justify-content: center;
		.button{
			height:40px;
			padding: 0 20px;
		}
		>*+*{
			margin-left: 10px;
		}
	}
}
</style>

<script>
import { applicationUserManager } from '@/applicationUserManager'
import { orderClient } from '@/orderClient'
import { EventBus } from '@/event-bus.js'

export default {
	name: 'sendOrderItem',
	props: {
		order: Object
	},

	computed: {
		listOverlayTitle(){
			var email = this.$store.getters.user.profile.email
			var resource = this.resource('listOverlayTitle')
			return resource.replace('[0]', email)
		},
		orderItem: {
			get () {
				let order = this.$store.getters.orderById(this.order.id)
				if (order) {
					// Get real data from store
					this.$set(this, 'fakeItem', order)
					return order
				} else {
					// Get old fake data, because store data is removed
					return this.fakeItem
				}
			},
			set () {
				this.$store.commit('updateOrder', this.orderItem)
			}
		},
		amount () {
			var cart = this.orderItem.cart
			var amount = 0
			for (let index = 0; index < cart.length; index++) {
				const item = cart[index]
				amount += item.amount
			}
			if (amount === 1) {
				return `${amount} ${this.resource('product')}`
			} else {
				return `${amount} ${this.resource('products')}`
			}
		},
		price () {
			var cart = this.orderItem.cart
			var price = {
				currency: 'EUR',
				amount: 0
			}
			for (let index = 0; index < cart.length; index++) {
				const item = cart[index]
				price.amount += item.amount * item.price.amount
			}
			return price
		}
	},
	methods: {
		resource (item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		readyOrder(){
			let type = 'Order'
			this.send(type)
		},
		readyList(){
			this.listOverlay = false
			let type = 'OrderList'
			this.send(type)
		},
		send (type) {
			this.status = 'sending'
			var cart = this.order.cart
			var order = {
				id: this.order.id,
				clientId: this.order.client.id,
				orderEmail: this.order.client.contact.email,
				lines: [],
				createdOn: new Date(this.order.added).toISOString(),
				productsLastSynced: new Date(window.localStorage.getItem('lastUpdateProducts') * 1000).toISOString(),
				clientsLastSynced: new Date(window.localStorage.getItem('lastUpdateClients') * 1000).toISOString(),
				type
			}

			for (let i = 0; i < cart.length; i++) {
				const item = cart[i]
				if (item.scan === 'ok' || item.scan === 'replace') {
					const line = {
						productId: item.id,
						quantity: item.amount
					}
					order.lines.push(line)
				}
			}
			this.placeOrder(order)
		},
		async placeOrder (order) {
			var $this = this
			try {
				let user
				if (process.env.VUE_APP_ENABLE_LOGIN === 'true') {
					user = await applicationUserManager.getUser()
					if (!user) {
						await applicationUserManager.login()
						return
					}

					orderClient
						.postOrder(
							{
								uri:
									'https://pgz-gateway.nextchapter-ecommerce.com/',
								tenant: user.profile.tenant,
								language: this.$store.state.app.language,
								access_token: user ? user.access_token : null,
								appVersion: window.appVersion,
								env: process.env.VUE_APP_ENV
							},
							order
						)
						.then(() => {
							$this.status = 'succes'
							$this.$emit('sent', this.order.id)
						})
						.catch(error => {
							console.error(error)
							$this.status = 'error'
						})
				} else {
					$this.status = 'succes'
					$this.$emit('sent', this.order.id)
				}
			} catch (e) {
				console.error(e)
				EventBus.$emit('error', e)
			}
		}
	},
	data () {
		return {
			fakeItem: {},
			deletePrompt: false,
			listOverlay: false,
			status: '',
			res: {
				nl: {
					startDateOrder: 'Order gestart op:',
					product: 'artikel',
					products: 'artikelen',
					sendOrder: 'Verstuur order',
					sendList: 'Verstuur bestellijst',
					succes: 'Succesvol verstuurd',
					error: 'Versturen mislukt',
					listOverlayTitle: 'Weet u zeker dat u deze bestellijst wilt versturen naar [0]?',
					listOverlayText: 'De bestellijst zal binnen 5 minuten in het account van de B2B webshop getoond worden.',
					confirm: 'Ja',
					cancel: 'Annuleer'
				},
				fr: {
					startDateOrder: 'La commande a commencé le:',
					product: 'article',
					products: 'articles',
					sendOrder: 'Envoyer la commande',
					sendList: 'Envoyer la liste des commandes',
					succes: 'Envoyé avec succès',
					error: 'Envoi échoué',
					listOverlayTitle: 'Voulez-vous vraiment envoyer cette liste de commandes à [0]?',
					listOverlayText: 'La liste des commandes sera affichée dans le compte de la boutique en ligne B2B dans les 5 minutes.',
					confirm: 'Oui',
					cancel: 'Annuler'
				}
			}
		}
	}
}
</script>
